<template>
  <div class="bg_base">
    <div class="temp_wave">
      <img
        src="../../assets/img/V.1 020921 Journey Background Wave Comp0.png"
        width="100%"
        alt=""
      />
    </div>
    <div class="temp_result">
      <div class="pb-3"></div>
      <section class="logo d-flex justify-center">
        <img src="../../assets/img/logo-teman-bakat.png" height="90px" alt="" />
      </section>
      <section class="logo d-flex justify-center">
        <img
          src="../../assets/img/workingStyle/Misi Working Style-Header.png"
          height="90px"
          alt=""
        />
      </section>
      <section v-for="(i, key) in result" :key="key" class="mb-3 pb-3">
        <section class="pa-3 d-flex flex-column align-center">
          <img
            v-if="key == 'Realistic'"
            src="../../assets/img/workingStyle/Misi Working Style-Icon Realistic0.png"
            height="120px"
            alt=""
            class="mb-3"
          />
          <img
            v-if="key == 'Intelligent'"
            src="../../assets/img/workingStyle/Misi Working Style-Icon Intelligent0.png"
            height="120px"
            alt=""
            class="mb-3"
          />
          <img
            v-if="key == 'Social'"
            src="../../assets/img/workingStyle/Misi Working Style-Icon Social0.png"
            height="120px"
            alt=""
            class="mb-3"
          />
          <img
            v-if="key == 'Conventional'"
            src="../../assets/img/workingStyle/Misi Working Style-Icon Conventional0.png"
            height="120px"
            alt=""
            class="mb-3"
          />
          <img
            v-if="key == 'Enterprising'"
            src="../../assets/img/workingStyle/Misi Working Style-Icon Enterprising0.png"
            height="120px"
            alt=""
            class="mb-3"
          />
          <img
            v-if="key == 'Artistic'"
            src="../../assets/img/workingStyle/Misi Working Style-Icon Artistic0.png"
            height="120px"
            alt=""
            class="mb-3"
          />
          <v-btn rounded color="#1e656c" class="mb-3" depressed dark>
            <strong>{{ key }}</strong>
          </v-btn>

          <div class="px-3 text-center">
            <p v-html="i.deskripsi"></p>
          </div>
        </section>
      </section>
    </div>
    <uiDownload />
  </div>
</template>

<script>
import uiDownload from "../downloadScheme/uiDownload.vue";
export default {
  components: { uiDownload },
  name: "resultWorkingstyle",
  data() {
    return {
      result: "",
    };
  },
  mounted() {
    let data = JSON.parse(localStorage.getItem("tesgayakerja"));
    this.result = JSON.parse(data.result);
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.bg_base {
  position: relative;
  background: url("../../assets/img/Misi1-3-2Report Background.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  min-height: 100vh;
  /* padding-top: 30px; */
}
.logo {
  margin-bottom: 30px;
}
.temp-pyramid {
  position: relative;
}
.type {
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.rounded-max {
  border-radius: 15px;
}
.code {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  background: #1e656c;
  color: white;
}
.temp_wave {
  top: 0;
  position: absolute;
}
.temp_result {
  position: relative;
  z-index: 2;
}
</style>
